module.exports = __webpack_public_path__ + "img/elementwidths_jakp.f63464ba.png";